////////////////// Sticky Navigation Bar ///////////////////

$(window).scroll(function () {
  if ($(this).scrollTop() > 100) {
    $('.navbar').addClass('sticky-nav')
  } else {
    $('.navbar').removeClass('sticky-nav')
  }
});

/////////////// Trending Best Sellers Product Slider ////////////////////////

jQuery("#bestSellers_product_carousel").owlCarousel({
  autoplay: true,
  rewind: true, /* use rewind if you don't want loop */
  margin: 15,
  loop: true,
  /*
 animateOut: 'fadeOut',
 animateIn: 'fadeIn',
 */
  responsiveClass: true,
  autoHeight: true,
  autoplayTimeout: 4000,
  smartSpeed: 1000,
  nav: true,
  responsive: {
    0: {
      items: 2
    },

    600: {
      items: 2
    },

    1024: {
      items: 4
    },

    1366: {
      items: 5
    }
  }
});

/////////////// Testimonial Slider ////////////////////////

jQuery("#testimonial").owlCarousel({
  autoplay: true,
  rewind: true, /* use rewind if you don't want loop */
  margin: 20,
  loop: true,
  /*
 animateOut: 'fadeOut',
 animateIn: 'fadeIn',
 */
  responsiveClass: true,
  autoHeight: true,
  autoplayTimeout: 4000,
  smartSpeed: 2000,
  nav: true,
  responsive: {
    0: {
      items: 1
    },

    500: {
      items: 2
    },

    600: {
      items: 3
    },

    768: {
      items: 2
    },

    1024: {
      items: 3
    },

    1366: {
      items: 3
    }
  }
});

// ---On Click Navigation Button In mobile--- //
$(document).ready(function () {
  $(".navbar-toggler-icon").click(function () {
    $(".fa-bars").toggleClass("fa-times");
    // $(".fa-bars").toggleClass("fa-bars");
  });
});

// Quality Counter JS
function increaseCount(a, b) {
  var input = b.previousElementSibling;
  var value = parseInt(input.value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  input.value = value;
}

function decreaseCount(a, b) {
  var input = b.nextElementSibling;
  var value = parseInt(input.value, 10);
  if (value > 1) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
  }
}


// Click On Purchase Secon option show offer para
$(document).ready(function () {
  $(".subscribe-offer-para").hide();
  $(".subscribe-offer").click(function () {
    $(".subscribe-offer-para").show();
  });

  $(".onetime-purchase").click(function () {
    $(".subscribe-offer-para").hide();
  });
});


//----------- FAQs JS --------------//
const items = document.querySelectorAll(".accordion button");

function toggleAccordion() {
  const itemToggle = this.getAttribute('aria-expanded');

  for (i = 0; i < items.length; i++) {
    items[i].setAttribute('aria-expanded', 'false');
  }

  if (itemToggle == 'false') {
    this.setAttribute('aria-expanded', 'true');
  }
}

items.forEach(item => item.addEventListener('click', toggleAccordion));





// =========== On hover Video Play JS ================== //

var figure = $(".video-item").hover(hoverVideo, hideVideo);

function hoverVideo(e) {
  $('video', this).get(0).play();
}
function hideVideo(e) {
  $('video', this).get(0).pause();
}